export function getDeltaYear(year) {
    return new Date().getFullYear() - year;
}

export function calulateBrandIncrement(brand) {
    let increment;
    switch (brand) {
        case 'europeo':
            increment = 1.30;
            break;
        case 'americano':
            increment = 1.15;
            break;
        case 'asiatico':
            increment = 1.05;
            break;
        default:
            break;
    }
    return increment;
}

// calcular el tipo de seguro

export function getPlanType(plan) {
    return (plan === 'basic' ? 1.20 : 1.50);
}

//get first letter uppercase
export function getFirstUppercase(text) {
    return text.charAt(0).toUpperCase() + text.slice(1);
}